import { ArrowRight } from "lucide-react";

export default function Nav() {
  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 z-50 bg-[#0b0c10]/90 backdrop-blur-md border-b border-[#24283b] px-6 lg:px-12 py-4 flex items-center justify-between"
    >
      <a href="#top" className="flex items-center gap-3 group" data-testid="nav-logo-link">
        <img
          src="/goat-mark.jpg"
          alt="GOAT Productions logo"
          className="h-10 transition-transform duration-500 group-hover:scale-105"
        />
        <div className="flex flex-col">
          <span className="font-display text-xl tracking-wider uppercase text-white leading-none">
            GOAT PRODUCTIONS
          </span>
          <span className="font-mono-goat text-[9px] uppercase tracking-widest text-[#45f3ff]">
            Digital • Physical Studio
          </span>
        </div>
      </a>

      <div className="hidden md:flex items-center gap-8 font-mono-goat text-xs uppercase tracking-widest text-neutral-400">
        <a href="#services" data-testid="nav-services-link" className="hover:text-[#45f3ff] transition-colors">
          Services
        </a>
        <a href="#ecosystem" data-testid="nav-capability-link" className="hover:text-[#45f3ff] transition-colors">
          Capability
        </a>
        <a href="#quote" data-testid="nav-quote-link" className="hover:text-[#45f3ff] transition-colors">
          Quote
        </a>
      </div>

      <a
        href="#quote"
        data-testid="nav-launch-project-btn"
        className="inline-flex items-center gap-2 bg-[#45f3ff] text-black font-mono-goat font-bold text-xs uppercase tracking-wider px-5 py-2.5 rounded-none hover:bg-white transition-colors"
      >
        <span>Launch Project</span>
        <ArrowRight className="w-3.5 h-3.5" />
      </a>
    </nav>
  );
}
